import { getReferenceString } from '@medplum/core';
import { patientAccessCardKindForUser } from '@/components/Timeline/TimelineItems/PatientAccessCall/patientAccessCardKind';
import { AppointmentWithEncounter } from '../types';

export type ChartingLinkTarget =
  /** A Patient Access call card; the timeline's Chart row starts it in one click. */
  { kind: 'chart-the-call'; focus: string } | { kind: 'view-chart'; focus: string } | { kind: 'create-chart-note' };

export interface ChartingPermissions {
  canCreatePatientAccessNote: boolean;
  canViewClinicalRecord: boolean;
}

/**
 * Which chart link the appointment popover offers, if any.
 *
 * A Patient Access rep charts a call with a script card (a Communication), so those
 * appointments send them to the card rather than into the Encounter flow, which would chart
 * the call twice. Everything else is the clinical record: a role that cannot view it gets no
 * link at all, because "Create a new chart note" would lead to a note it can never save, and
 * the Calendar no longer asks for the Encounter join on its behalf (BAR-2660). Mirrors the
 * gate on AppointmentTimelineItem.
 */
export function resolveChartingLink(
  resource: AppointmentWithEncounter,
  permissions: ChartingPermissions
): ChartingLinkTarget | null {
  if (patientAccessCardKindForUser(resource, permissions.canCreatePatientAccessNote)) {
    const focus = getReferenceString(resource);
    return focus ? { kind: 'chart-the-call', focus } : null;
  }

  if (!permissions.canViewClinicalRecord) {
    return null;
  }

  if (resource.encounter) {
    const focus = getReferenceString(resource.encounter);
    return focus ? { kind: 'view-chart', focus } : null;
  }

  return { kind: 'create-chart-note' };
}
